import type { LabelsByCountryItemDto, PublicPickupPointDto, PublicStatsDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PublicStatsService {
  apiName = 'Default';


  getPublicStats = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, PublicStatsDto>({
      method: 'GET',
      url: '/api/app/public-stats',
    },
    { apiName: this.apiName,...config });


  getLabelsByCountry = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, LabelsByCountryItemDto[]>({
      method: 'GET',
      url: '/api/app/public-stats/labels-by-country',
    },
    { apiName: this.apiName,...config });


  getPickupPoints = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, PublicPickupPointDto[]>({
      method: 'GET',
      url: '/api/app/public-stats/pickup-points',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
